import React, { useCallback, useRef, useState } from 'react'
import ReactCrop, { Crop } from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'
import { StyleSheet } from 'react-native'

import commonStyles from 'utils/styles/commonStyles'

import { MediaCrop } from 'types/media'

interface Props {
  circularCrop?: boolean
  cropSettings: MediaCrop
  onChange: (newCrop: MediaCrop) => void
  src: string
}

export const ImageCropper = ({ circularCrop, cropSettings, onChange, src }: Props) => {
  const [width, setWidth] = useState<string | number>('unset')
  const scaleFactor = useRef(1)
  const [internalCropSettings, setInternalCropSettings] = useState<Partial<Crop>>(cropSettings)

  const styles = StyleSheet.create({
    crop: {
      display: 'flex',
      flex: 1,
      width,
    },
  })

  const handleChange = useCallback(
    (crop: Partial<Crop>) => {
      setInternalCropSettings(crop)
      const scaledCrop: MediaCrop = {
        ...crop,
        height: crop.height ? Math.round(crop.height * scaleFactor.current) : 0,
        width: crop.width ? Math.round(crop.width * scaleFactor.current) : 0,
        x: crop.x ? Math.round(crop.x * scaleFactor.current) : 0,
        y: crop.y ? Math.round(crop.y * scaleFactor.current) : 0,
        unit: 'px',
      }

      onChange(scaledCrop)
    },
    [onChange, scaleFactor, setInternalCropSettings],
  )

  const onLoad = useCallback((img: HTMLImageElement) => {
    scaleFactor.current = img.naturalHeight / img.clientHeight
    setWidth(img.clientWidth)
  }, [])

  return (
    <ReactCrop
      src={src}
      circularCrop={circularCrop}
      crop={internalCropSettings}
      onChange={handleChange}
      onImageLoaded={onLoad}
      style={styles.crop}
      imageStyle={commonStyles.fullHeight}
    />
  )
}
